import { ICellRendererAngularComp } from '@ag-grid-community/angular';
import { Component } from '@angular/core';
import { ICellRendererParams } from '@ag-grid-community/core';

@Component({
    selector: 'prox-check-renderer',
    template: `<i [class]="iconClass"></i>`,
    styles: [],
    standalone: false
})
export class CheckOnlyRendererComponent implements ICellRendererAngularComp {
  params: any;
  iconClass = '';

  agInit(params: ICellRendererParams) {
    const isChecked = !!this.getValueToDisplay(params);
    this.iconClass = isChecked ? 'pi pi-check text-green-600 text-xl font-bold' : '';
  }

  refresh(params: ICellRendererParams) {
    return true;
  }

  getValueToDisplay(params: ICellRendererParams) {
    return params.value;
  }
}
